module.exports = __webpack_public_path__ + "img/单一品类数据.b81fead5.png";